import { PRODUCTS } from '@traceio-org/platform-contracts';
import agentsBlack from '../../assets/brand/trace-agents-black.svg';
import customerPortalBlack from '../../assets/brand/trace-customer-portal-black.svg';
import enterpriseBlack from '../../assets/brand/trace-enterprise-black.svg';
import enterpriseWhite from '../../assets/brand/trace-enterprise-white.svg';
import brokersBlack from '../../assets/brand/trace-for-brokers-black.svg';
import brokersWhite from '../../assets/brand/trace-for-brokers-white.svg';
import carriersBlack from '../../assets/brand/trace-for-carriers-black.svg';
import carriersWhite from '../../assets/brand/trace-for-carriers-white.svg';
import fullObsidian from '../../assets/brand/trace-full-obsidian.svg';
import fullWhite from '../../assets/brand/trace-full-white.svg';
import markObsidian from '../../assets/brand/trace-mark-obsidian.svg';
import markPeel from '../../assets/brand/trace-mark-peel.svg';
import markWhite from '../../assets/brand/trace-mark-white.svg';
export const LOCKUPS = {
    trace: {
        id: 'trace',
        alt: 'Trace',
        width: 537.77,
        height: 102.6,
        light: { file: 'trace-full-obsidian.svg', url: fullObsidian },
        dark: { file: 'trace-full-white.svg', url: fullWhite, invert: false },
    },
    'trace-enterprise': {
        id: 'trace-enterprise',
        alt: PRODUCTS.enterprise.displayName,
        width: 689.57,
        height: 81.19,
        light: { file: 'trace-enterprise-black.svg', url: enterpriseBlack },
        dark: { file: 'trace-enterprise-white.svg', url: enterpriseWhite, invert: false },
    },
    'trace-for-brokers': {
        id: 'trace-for-brokers',
        alt: PRODUCTS.brokers.displayName,
        width: 705.46,
        height: 71.62,
        light: { file: 'trace-for-brokers-black.svg', url: brokersBlack },
        dark: { file: 'trace-for-brokers-white.svg', url: brokersWhite, invert: false },
    },
    'trace-for-carriers': {
        id: 'trace-for-carriers',
        alt: PRODUCTS.carriers.displayName,
        width: 704.03,
        height: 71.62,
        light: { file: 'trace-for-carriers-black.svg', url: carriersBlack },
        dark: { file: 'trace-for-carriers-white.svg', url: carriersWhite, invert: false },
    },
    'trace-agents': {
        id: 'trace-agents',
        alt: PRODUCTS.agents.displayName,
        width: 595.36,
        height: 76.76,
        light: { file: 'trace-agents-black.svg', url: agentsBlack },
        dark: { file: 'trace-agents-black.svg', url: agentsBlack, invert: true },
    },
    'trace-customer-portal': {
        id: 'trace-customer-portal',
        alt: PRODUCTS.portal.displayName,
        width: 858.9,
        height: 71.62,
        light: { file: 'trace-customer-portal-black.svg', url: customerPortalBlack },
        dark: { file: 'trace-customer-portal-black.svg', url: customerPortalBlack, invert: true },
    },
};
/** The Trace logomark alone, for favicons and compact marks. */
export const TRACE_MARK = {
    obsidian: { file: 'trace-mark-obsidian.svg', url: markObsidian },
    peel: { file: 'trace-mark-peel.svg', url: markPeel },
    white: { file: 'trace-mark-white.svg', url: markWhite },
};
export function lockupForProduct(productKey) {
    return LOCKUPS[PRODUCTS[productKey].lockup];
}
/** One line of product copy for sign-in pages. */
export const PRODUCT_TAGLINES = {
    enterprise: 'Freight management for shippers.',
    brokers: 'The brokerage operating system.',
    carriers: 'Carrier and asset operations.',
    agents: 'Agents that work in your TMS, inbox and phones.',
    portal: 'Quotes, shipments and documents from your logistics provider.',
    admin: 'Trace staff only.',
};
//# sourceMappingURL=lockups.js.map